export default [
  {
    name: "orderstore_index_stat",
    path: "/offline-stores/stats",
    component: () => import("../pages/global/syncunion/statistics.vue"),
  },
  {
    name: "orderstore_index",
    path: "/offline-stores/order",
    component: () => import("../pages/union/order/index.vue"),
  },
  {
    name: "promobank_list",
    path: "/offline-stores/promo-bank",
    component: () => import("../pages/union/promo-bank/index.vue"),
  },
  {
    name: "promobank_create",
    path: "/offline-stores/promo-bank/create",
    component: () => import("../pages/union/promo-bank/manage.vue"),
  },
  {
    name: "promobank_update",
    path: "/offline-stores/promo-bank/update/:id",
    component: () => import("../pages/union/promo-bank/manage.vue"),
  },
  {
    name: "tokovouchers_list",
    path: "/offline-stores/vouchers",
    component: () => import("../pages/union/vouchers/index.vue"),
  },
  {
    name: "tokovouchers_update",
    path: "/offline-stores/vouchers/update/:id",
    component: () => import("../pages/union/vouchers/update.vue"),
  },
  {
    name: "stamp_list",
    path: "/offline-stores/stamp",
    component: () => import("../pages/union/stamp/index.vue"),
  },
  {
    name: "synctoko_index",
    path: "/offline-stores/sync-monitoring",
    component: () => import("../pages/union/monitoring/sync-progress.vue"),
    // component: () => import("../pages/union/monitoring/index.vue"),
    // component: () => import("../pages/global/syncunion/index.vue"),
  },
  {
    name: "storelocw_index",
    path: "/offline-stores/store",
    component: () => import("../pages/website/store/index.vue"),
  },
  {
    name: "storelocw_create",
    path: "/offline-stores/store/create",
    component: () => import("../pages/website/store/manage.vue"),
  },
  {
    name: "storelocw_update",
    path: "/offline-stores/store/update/:id",
    component: () => import("../pages/website/store/manage.vue"),
  },
  {
    name: "promotionpos_index",
    path: "/offline-stores/promotion",
    component: () => import("../pages/union/promotions/index.vue"),
  },
  {
    name: "promotionpos_create",
    path: "/offline-stores/promotion/create",
    component: () => import("../pages/union/promotions/create.vue"),
  },
  {
    name: "promotionpos_edit",
    path: "/offline-stores/promotion/edit/:id",
    component: () => import("../pages/union/promotions/create.vue"),
    props: true,
  },
  {
    name: "promotionpos_product_detail",
    path: "/offline-stores/promotion/product",
    component: () => import("../pages/union/promotions/product-detail.vue"),
  },

];


